import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppAuthData } from '@/stores/app/authData';
import { useTranslateJob } from '@/stores/document/translateJob';
import { useEditor } from '@/stores/editor/editor';
import {
  isTranslationSupported,
  TRANSLATION_UNSUPPORTED_TOOLTIP,
} from '@/helpers/language';

export const TRANSLATION_SAVING_TOOLTIP = 'Saving changes...';

export const useTranslateJobButton = () => {
  const { authData } = storeToRefs(useAppAuthData());
  const {
    isEditable,
    documentType,
    isSharePage,
    languageCode,
    isRevisionSaving,
  } = storeToRefs(useEditor());
  const translateJobStore = useTranslateJob();

  const visible = computed(() => Boolean(
    isEditable.value
    && ['job', 'job_template'].includes(documentType.value)
    && !isSharePage.value
    && authData.value.aiEnabled
    && authData.value.jobTranslationEnabled,
  ));

  const disabled = computed(() => (
    Boolean(isRevisionSaving.value) || !isTranslationSupported(languageCode.value)
  ));

  const tooltip = computed(() => {
    if (!disabled.value) return '';
    if (isRevisionSaving.value) return TRANSLATION_SAVING_TOOLTIP;
    return TRANSLATION_UNSUPPORTED_TOOLTIP;
  });

  const open = () => {
    if (!visible.value || disabled.value) return;
    translateJobStore.setModalVisible(true);
  };

  return {
    visible,
    disabled,
    tooltip,
    open,
  };
};
